// Network Error Handling Actions
export const HANDLE_API_ERROR = 'HANDLE_API_ERROR';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const AUTH_ERROR = 'AUTH_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
export const HIDE_ERROR_MESSAGE = 'HIDE_ERROR_MESSAGE';
export const SET_ERROR_CONTEXT = 'SET_ERROR_CONTEXT';

// Action Creators
export const handleApiError = (error, context = 'unknown') => ({
  type: HANDLE_API_ERROR,
  payload: { error, context }
});

export const networkError = (error, context, message) => ({
  type: NETWORK_ERROR,
  payload: { error, context, message }
});

export const authError = (error, context, message) => ({
  type: AUTH_ERROR,
  payload: { error, context, message }
});

export const clearError = () => ({
  type: CLEAR_ERROR
});

export const showErrorMessage = (message, type, context) => ({
  type: SHOW_ERROR_MESSAGE,
  payload: { message, type, context }
});

export const hideErrorMessage = () => ({
  type: HIDE_ERROR_MESSAGE
});

export const setErrorContext = (context) => ({
  type: SET_ERROR_CONTEXT,
  payload: { context }
});
